import { Grid, TextField, Typography } from '@mui/material';
import React from 'react';
import CustomButton from '../../components/Button/Button';
import { socialIcons } from '../../components/Header/Header';
import useData from '../../Hooks/useData';
import { TitleSection } from '../Resume/Resume';
import './Contact.css'

const Contact = () => {
    const { phone1, address, email } = useData()
    return (
        <Grid container spacing={5} className="section">

            {/* Contact Form  */}
            <Grid item xs={12} lg={7}>
                <Grid container>
                    <Grid item>
                        <TitleSection text={"Contact Form"} />
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={6}>
                                <TextField variant="standard" id="standard-basic" fullWidth name="name" label="Name" />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField variant="standard" id="standard-basic" fullWidth name="email" label="E-mail" />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField variant="standard" id="standard-basic" fullWidth name="message" label="Message" multiline rows={3} />
                            </Grid>
                            <Grid item xs={12} >
                                <CustomButton text={'Submit'} />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

            </Grid>

            {/* Contact Information  */}
            <Grid item xs={12} lg={5}>
                <Grid container>
                    <Grid item>
                        <TitleSection text={"Contact Information"} />
                    </Grid>

                    <Grid item xs={12}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Typography className="contactInfo-item">
                                    <span>Address: </span>{address}
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography className="contactInfo-item">
                                    <span>Phone: </span>{phone1}
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography className="contactInfo-item">
                                    <span>E-mail: </span> {email}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12}>
                        <Grid container className="contactInfo-socialContainer">
                            {
                                socialIcons.map(i=>(
                                    <Grid key={i.id} item className="contactInfo-social">
                                        <a href={i.link} target="_blank" rel="noopener noreferrer">{i.name}</a>
                                    </Grid>
                                ))
                            }
                        </Grid>
                    </Grid>

                </Grid>
            </Grid>
        </Grid>
    );
};

export default Contact;